import './assets/style.css'
// 导入three.js
import * as THREE from 'three'
import $, { data } from 'jquery'
import NProgress from 'nprogress'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper'
import { VertexTangentsHelper } from 'three/examples/jsm/helpers/VertexTangentsHelper'
import { NodeMaterial } from 'three/examples/jsm/nodes/materials/NodeMaterial'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import gsap from 'gsap'
import * as dat from 'dat.gui'
import { Light, LineCurve, MeshBasicMaterial } from 'three';
import { add, func } from 'three/examples/jsm/nodes/nodes'
let timer
function progressStart() {
    let start = 0;
    $('.progress-inner').css('left', (-100+start) + '%')
    timer = setInterval(function () {
        if (start < 94) {
            start += Math.random() * 5;
        }
        $('.progress-inner').css('left', (-100+start) + '%')
    }, 500)

}
function progressSet(num) {
    let start = num * 100;
    $('.progress-inner').css('left', (-100+start) + '%')
    clearInterval(timer)
}
function progressDone() {
    let start = 100;
    $('.progress-inner').css('left', (-100+start) + '%')
    clearInterval(timer)
    setTimeout(function () {
        $('.progress').hide()
    }, 500)
}
progressStart()
function initRender() { }
// 渲染器
const render = new THREE.WebGLRenderer({
    antialias: true,
    logarithmicDepthBuffer: false,
    shadowMapEnabled: true
})
render.setClearAlpha(0.0)
render.setSize(window.innerWidth, window.innerHeight)
render.outputEncoding = THREE.sRGBEncoding;
// 场景
const scene = new THREE.Scene()

let cameraStartP = 0.7
let cameraEndP = 1.5
// 相机
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
//位置移动
camera.position.set(0.7, 0, 1.9)

// 轨道控制器
const controls = new OrbitControls(camera, render.domElement)
//设置控制器阻尼
controls.enableDamping = true
controls.enablePan = false
controls.minDistance = 1.7;
controls.maxDistance = 2.7;
controls.enableZoom = false;
// const gui = new dat.GUI()
// gui.add(camera.position, 'x').min(0).max(5)
// gui.add(camera.position, 'y').min(0).max(5)
// gui.add(camera.position, 'z').min(0).max(5)


// 上
let ligth1 = new THREE.DirectionalLight(0xffffff, 0.7)
ligth1.position.set(0, 10, 0)
// ligth1.castShadow=true
scene.add(ligth1)


// 下
let ligth2 = new THREE.DirectionalLight(0xffffff, 0.7)
ligth2.position.set(0, -10, 0)
scene.add(ligth2)
// 左s
let ligth3 = new THREE.DirectionalLight(0xffffff, 0.7)
ligth3.position.set(-10, 0, 0)
scene.add(ligth3)
//右
let ligth4 = new THREE.DirectionalLight(0xffffff, 0.7)
ligth4.position.set(10, 0, 0)
scene.add(ligth4)
//前
let ligth5 = new THREE.DirectionalLight(0xffffff, 0.7)
ligth5.position.set(0, 0, 10)
scene.add(ligth5)
//后
let ligth6 = new THREE.DirectionalLight(0xffffff, 0.7)
ligth6.position.set(0, 0, -10)
scene.add(ligth6)

let meshes = [];
let envMap
let animations = [];
let mixer
let first = true
const texture1 = new THREE.TextureLoader().load('assets/bg.jpg');
let PlaneGeometry = new THREE.PlaneGeometry(1, 1.3);
let material = new THREE.MeshBasicMaterial({
    color: '#000000', alphaMap: texture1,
    transparent: true,
    depthWrite: false
});
let plane = new THREE.Mesh(PlaneGeometry, material)
scene.add(plane)
plane.position.x = 0.43
plane.position.y = -0.32
plane.position.z = -0.19

plane.scale.set(3.1, 1.8, 1)
// gui.add(plane.position, 'x').min(-1).max(2).name('positonx')
// gui.add(plane.position, 'y').min(-1).max(2).name('positony')
// gui.add(plane.position, 'z').min(-1).max(2).name('positonz')
// gui.add(plane.scale, 'x').min(0).max(5).name('scalex')
// gui.add(plane.scale, 'y').min(0).max(5).name('scaley')
// gui.add(plane.scale, 'z').min(0).max(5).name('scalez')

const cubeTextureLoader = new THREE.CubeTextureLoader();
const envMapTexture = cubeTextureLoader.load([
    "assets/HDR.left.png",
    "assets/HDR.right.png",
    "assets/HDR.top.png",
    "assets/HDR.bottom.png",
    "assets/HDR.front.png",
    "assets/HDR.back.png"
])

const sphereGeometry = new THREE.SphereGeometry(1, 20, 20)
const mateial = new THREE.MeshStandardMaterial({
    metalness: 0.7,
    roughness: 0.1,
})

scene.background = envMapTexture

let group
let emissiveMap = []
const scaleSize = 0.5
let ledMate
let anniuMeta
let pcbMeta
let logoMeta
function loadModel() {

    new RGBELoader()
        .setPath('assets/textures/equirectangular/')
        .load('blouberg_sunrise_2_1k.hdr', function (texture) {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            envMap = texture

            // model
            const dracoLoader = new DRACOLoader()
            const loader = new GLTFLoader().setPath('/assets/model/50k-g3/');
            dracoLoader.setDecoderPath('/assets/YuanZhuiPoSuiJi/');
            loader.setDRACOLoader(dracoLoader)


            loader.load('25-50k-g3.gltf', function (gltf) {
                console.log(gltf)
                progressDone()
                meshes = []
                emissiveMap = []
                gltf.scene.traverse(function (mesh) {

                    if (mesh.isMesh) {
                        let tmpmesh = { ...mesh.material }
                        meshes.push(mesh)
                        mesh.material.emissiveMap = mesh.material.map;
                        let tmpEmissMap = {};
                        tmpEmissMap.roughness = mesh.material.roughness
                        tmpEmissMap.metalness = mesh.material.metalness
                        tmpEmissMap.color = mesh.material.color
                        emissiveMap.push(tmpEmissMap)
                        console.log(mesh.name, mesh.material.map)
                        if (mesh.name == "LED") {
                            ledMate = mesh.material.map;
                            // mesh.material.map=null
                        }
                        if (mesh.name == "M_Second_layer") {
                            anniuMeta = mesh.material.map;
                        }
                        if (mesh.name == "M_PCB") {
                            pcbMeta = mesh.material.map;
                        }
                        if (mesh.name == "logo") {
                            logoMeta = mesh.material;
                        }

                    }

                })


                gltf.scene.scale.set(scaleSize, scaleSize, scaleSize)

                mixer = new THREE.AnimationMixer(gltf.scene)
                gltf.animations.map(item => {
                    mixer.clipAction(item).loop = THREE.LoopOnce
                    mixer.clipAction(item).clampWhenFinished = true
                    mixer.clipAction(item).setDuration(1)
                    animations.push(mixer.clipAction(item))
                })
                scene.add(gltf.scene)
                scene.remove(gltf.scene.getObjectByName('LED'))

            }, function (e) {
                // progressSet(e.loaded / e.total)
            });
        });
}
loadModel()

document.getElementById("canvas").appendChild(render.domElement);

let clock = new THREE.Clock();

(function ani() {
    if (mixer) { mixer.update(clock.getDelta()) }
    controls.update()

    render.render(scene, camera)
    requestAnimationFrame(ani)

})()

$('.fenjie').on('click', function () {
    $('.btns div').removeClass("this")
    $(this).addClass("this")

    plane.material.opacity = 0
    meshes.forEach((element, index) => {
        element.material.opacity = 1
        element.material.roughness = emissiveMap[index].roughness
        element.material.metalness = emissiveMap[index].metalness
        element.material.color = emissiveMap[index].color
        element.material.envMap = null
        element.material.depthWrite = true
        element.material.transparent = false
        if (element.name == "LED") {
            element.material.map = ledMate;
        }
        if (element.name == "M_Second_layer") {
            element.material.map = anniuMeta;
        }
        if (element.name == "M_PCB") {
            element.material.map = pcbMeta;
        }
        if (element.name == 'logo') {
            logoMeta.transparent=true
            element.material = logoMeta
        }
    })
    meshes.forEach((element, index) => {
        element.material.opacity = 1
        element.material.roughness = emissiveMap[index].roughness
        element.material.metalness = emissiveMap[index].metalness
        element.material.color = emissiveMap[index].color
        element.material.envMap = null
        element.material.depthWrite = true
        element.material.transparent = false
        if (element.name == "LED") {
            element.material.map = ledMate;
        }
        if (element.name == "M_Second_layer") {
            element.material.map = anniuMeta;
        }
        if (element.name == "M_PCB") {
            element.material.map = pcbMeta;
        }
        if (element.name == 'logo') {
            logoMeta.transparent=true
            element.material = logoMeta
        }
    })

    animations.map(item => {
        item.play()
    })
    camera.zoom = 0.7
    camera.updateProjectionMatrix()
})

$('.hebing').on('click', function () {
    $('.btns div').removeClass("this")
    $(this).addClass("this")
    plane.material.opacity = 1
    console.log(meshes)
    camera.position.set(0.7, 0, 1.9)
    controls.minDistance = 1.7;
controls.maxDistance = 2.7;
    meshes.forEach((element, index) => {
        console.log(element.material.transparent)
        element.material.transparent = false
        element.material.opacity = 1
        element.material.roughness = emissiveMap[index].roughness
        element.material.metalness = emissiveMap[index].metalness
        element.material.color = emissiveMap[index].color
        element.material.envMap = null
        element.material.depthWrite = true
        if (element.name == 'LED') {
            element.material.map = ledMate
        }
        if (element.name == "M_Second_layer") {
            element.material.map = anniuMeta;
        }
        if (element.name == "M_PCB") {
            element.material.map = pcbMeta;
        }
        if (element.name == 'logo') {
            logoMeta.transparent=true
            element.material = logoMeta
            element.material = logoMeta
        }
    })
    meshes.forEach((element, index) => {
        element.material.transparent = false
        element.material.opacity = 1
        element.material.roughness = emissiveMap[index].roughness
        element.material.metalness = emissiveMap[index].metalness
        element.material.color = emissiveMap[index].color
        element.material.envMap = null
        element.material.depthWrite = true
        if (element.name == 'LED') {
            element.material.map = ledMate
        }
        if (element.name == "M_Second_layer") {
            element.material.map = anniuMeta;
        }
        if (element.name == "M_PCB") {
            element.material.map = pcbMeta;
        }
        if (element.name == 'logo') {
            logoMeta.transparent=true
            element.material = logoMeta
            element.material = logoMeta
        }
    })
    animations.map(item => {
        item.stop()
    })
    camera.zoom = 1
    camera.updateProjectionMatrix()
})

$('.touming').on('click', function () {
    $('.btns div').removeClass("this")
    $(this).addClass("this")
    animations.map(item => {
        item.stop()
    })
    plane.material.opacity = 0.6
    console.log(meshes)
    camera.position.set(0.7, 0, 1.9)
    controls.minDistance = 1.7;
    controls.maxDistance = 2.7;
    meshes.forEach(element => {
        element.material.transparent = true
        element.material.opacity = 0.3
        element.material.metalness = 1
        element.material.color = new THREE.Color(0xc1c1c1)
        element.material.roughness = 0.4
        element.material.envMap = envMap
        element.material.depthWrite = false
        if (element.name == "LED") {
            element.material.map = null;
        }
        if (element.name == "M_Second_layer" || element.name == "logo"||element.name == "M_PCB") {
            element.material = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                opacity: 0.3,
                metalness: 1,
                roughness: 0.4,
                envMap: envMap,
                depthWrite: true,
                transparent: true
            });
        }

    })
    camera.zoom = 1
    camera.updateProjectionMatrix()
})